export default __webpack_public_path__ + "static/media/Ivan Morsi.fdf24948.png";